"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanToString = void 0;
const booleanToString = (value) => (value === undefined ? undefined : value ? 'true' : 'false');
exports.booleanToString = booleanToString;
